import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DashboardApiService } from './db-api.service';

export interface SetupStatus {
  has_groups: boolean;
  has_designs: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SetupStatusApiService extends DashboardApiService {
  readonly API_URL = `/v1/issuer/organizations/${this.embedding.departmentId}/setup_status`;

  getSetupStatus(): Observable<SetupStatus> {
    return this._get(this.API_URL).pipe(
      map((res) => this._handleResponse(res, 'organization')),
      catchError((res) => this._handleError(res)),
    );
  }
}
